export default "__VITE_ASSET__94d6ae42__"